import React, { useEffect, useState } from "react";
import classes from "./ForecastDayPage.module.css"
import { backend_routes } from "../../../common/links";
import MyLoadingIcon from "../../UI/loadingIcon/MyLoadingIcon";
import { useAxiosGetRefreshing, useAxiosDeleteRefreshing } from "../../../hooks/useAxios";
import Forecast from "../../forecast/forecast";
import DoubleSelect from "../../UI/doubleSelect/DoubleSelect"

const ForecastsDayPage = function(){

    const [bodyLoaded, setBodyLoaded] = useState(false);
    const [hiddenMonth, setHiddenMonth] = useState(true);
    const [monthsByYearMap, setMonthsByYearMap] = useState();
    const [selectedYear, setYear] = useState(0);
    const [selectedMonth, setMonth] = useState(0);
    const [monthFC, setMonthFC] = useState(null);
    const [daysFC, setDaysFC] = useState([]);

    const [fetchMonthsByYears, isFetchLoading] = useAxiosGetRefreshing(
        function(response){
            setMonthsByYearMap(new Map(Object.entries(response.data.data)));
            setBodyLoaded(true);
        },
        function(badResponse){
            console.log(badResponse);
        }
    );
    
    const [fetchMonths, isMonthsLoading] = useAxiosGetRefreshing(
        function(response){
            setHiddenMonth(response.data.data.MonthForecast.month.startsWith('0001'));
            let month = response.data.data.MonthForecast;
            month.kind = "month";
            month.date = month.month;
            delete month.month;
            setMonthFC(month);
            for (const day of response.data.data.DayForecasts) {
                day.kind = "day";
                day.date = day.day;
                delete day.day;
            }
            setDaysFC(response.data.data.DayForecasts);
        },
        function(badResponse){
            console.log(badResponse);
        }
    );

    useEffect(()=>{
        fetchMonthsByYears(backend_routes.FORECASTS_AVAILABLE_MONTHS_LINK);
    },[])

    useEffect(()=>{
        if (selectedYear!==0 && selectedMonth!==0) 
        fetchMonths(backend_routes.FORECASTS_DAYS_AND_MONTH+selectedMonth+'.'+selectedYear);
    },[selectedYear,  selectedMonth])


    var deletingId;
    const handleChildElementClick = (e, id) => {
        e.stopPropagation();
        deletingId = id;
        deleteFC(backend_routes.FORECASTS_DELETE_LINK + "day/" + id);
    }
    const [deleteFC, isDeleteSending] = useAxiosDeleteRefreshing(
        async function (response) {
            if (response.data.data === 204) {
                setDaysFC(daysFC.filter(p => p.id !== deletingId));
            }
        },
        function (badResponse) {
            deletingId = 0;
            console.log(badResponse);
        }
    );


    return(
        <div className={classes.forecastsDayPage} style={{padding: "5px"}}>
            {isFetchLoading||!bodyLoaded
            ?<MyLoadingIcon/>
            :<DoubleSelect map={monthsByYearMap} settingFirstCallback={setYear} settingSecondCallback={setMonth}/>
            }
            <br/>
            {isMonthsLoading || isDeleteSending
            ?<MyLoadingIcon/>
            :monthFC===null
                ?<div></div>
                :<div>
                    {
                    !hiddenMonth
                                ? <Forecast style={{ backgroundColor: "var(--color-official-active-button)" }} kind={"month"} hidden={true} forecast={monthFC} />
                    :<></>
                    }
                    
                {daysFC.map(item =>
                    <Forecast key={item.date} kind={"day"} forecast={item}>
                        <div className="deleteButton" onClick={(e) => handleChildElementClick(e, item.id)}>Удалить</div>
                    </Forecast>
                )}
            </div>
            }
        </div>
    );
}
export default ForecastsDayPage;